import React from 'react';
import Slider from 'react-slick';
import { MdDelete } from 'react-icons/md';
import { IoMdStar } from 'react-icons/io';
import UserAvatar from '../UserAvatar';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const BusinessReviewCarousel = ({ businessData, handleDelete }) => {
  const ratings = businessData?.ratings || [];

  const settings = {
    dots: true,
    infinite: ratings.length > 1,
    speed: 500,
    slidesToShow: Math.min(2, ratings.length),
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (ratings.length === 0) {
    return (
      <div className="p-2 mt-6 bg-white rounded-lg shadow-sm">
        <div className="items-start justify-center px-2 py-3">
          <p className="text-base font-semi text-[#191B1C] px-2">Business Review</p>
          <p className="mt-2 text-xs font-light text-gray-500">No reviews yet</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-2 mt-6 bg-white rounded-lg shadow-sm">
      <div className="w-full mt-2 bg-white rounded-lg">
        <div className="items-start justify-center px-2 py-3">
          <p className="text-base font-semibold text-[#191B1C] px-2">Business Review</p>
        </div>
        <div className="p-4 pb-10 w-full max-w-[800px] mx-auto">
          <Slider {...settings} className="custom-slider">
            {ratings.map((rating, index) => (
              <div key={rating._id || index} className="px-2">
                <div className="relative p-4 border rounded-lg h-[150px]">
                  <button
                    className="absolute text-gray-500 top-2 right-2 hover:text-red-500"
                    onClick={() => handleDelete(rating._id)}>
                    <MdDelete className="w-4 h-4 text-red-500" />
                  </button>

                  <div className="flex items-start gap-4 mb-3">
                    <UserAvatar user={rating?.userId} />
                    <div className="flex-1">
                      <h2 className="font-light text-sm text-[#191B1C]">
                        {rating.userId
                          ? `${rating.userId.firstName || ''} ${rating.userId.lastName || ''}`
                          : 'Anonymous User'}
                      </h2>
                      <p className="font-light text-[8px] text-[#7B878C]">
                        {rating?.userId?.title}
                      </p>
                      <div className="flex mt-1">
                        {[...Array(5)].map((_, starIndex) => (
                          <IoMdStar
                            key={starIndex}
                            className={`w-3 h-3 ${
                              starIndex < (rating?.rating || 0) ? 'text-[#E67136]' : 'text-gray-100'
                            }`}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="font-light text-[8px] text-[#7B878C]">
                    {rating?.comment || 'No comment provided'}
                  </p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default BusinessReviewCarousel;
